<template>
    <div class="apply-login-wrap">
        <div class="form-popup-title">{{ $t('SINGUP') }}</div>
        <div style="display: flex; max-width: 100%">
            <LoginTextInput
                :errors="errors"
                :label="$t('LABEL_FIRSTNAME')"
                icon="format_size"
                name="name"
                style="width: 40%"
                v-model.trim="form.name"
            />
            <LoginTextInput
                :errors="errors"
                :label="$t('LABEL_LASTNAME')"
                icon="format_size"
                name="surname"
                style="width: 56%; margin-left: 4%"
                v-model.trim="form.surname"
            />
        </div>
        <LoginTextInput
            :errors="errors"
            :label="$t('PLACEHOLDER_EMAIL')"
            icon="mail"
            name="mail"
            v-model.trim="form.mail"
        />
        <LoginTextInput
            :errors="errors"
            :label="$t('PHONE')"
            icon="phone"
            name="phone"
            type="number"
            v-model.trim="form.phone"
        />
        <div style="display: flex; max-width: 100%">
            <LoginTextInput
                :errors="errors"
                :label="$t('LABEL_PASS')"
                icon="lock"
                name="password"
                style="width: 48%"
                type="password"
                v-model.trim="form.password"
            />
            <LoginTextInput
                :errors="errors"
                :label="$t('PLACEHOLDER_PASSWORD_CONFIRM')"
                icon="lock"
                name="repeatPassword"
                style="width: 48%; margin-left: 4%"
                type="password"
                v-model.trim="form.repeatPassword"
            />
        </div>
        <LoginSelectInput
            :options="languageOptions"
            v-model="form.language"
            @input="changeLanguage"
            :errors="errors"
            name="language"
            :label="$t('LABEL_APP_LANGUAGE')"
            icon="language"
        />
        <div class="login-comment" style="margin-top: 1rem">
            {{ $t('SIGNUP_REGULATIONS_TITLE') }}
        </div>
        <div class="login-checkbox">
            <Checkbox v-model="form.regulations" />
            <div
                @click="$env.getRegulations('regulations')"
                class="login-checkbox-text"
            >
                {{ $t('READ_CONTENT_AND_ACCEPT_RULES') }}
            </div>
        </div>
        <div class="login-checkbox">
            <Checkbox v-model="form.privacy" />
            <div
                @click="$env.getRegulations('privacy')"
                class="login-checkbox-text"
            >
                {{ $t('READ_CONTENT_AND_ACCEPT_PRIVACY') }}
            </div>
        </div>
        <ActionButton
            :loading="loading"
            @click="submit"
            style="margin-top: 2rem"
            label="BUTTON_LOGIN"
        />
        <div class="login-actions-row" @click="goBack">
            <span class="login-action">{{ $t('BUTTON_BACK') }}</span>
        </div>
    </div>
</template>
<script>
import { languageOptions } from '@/helpers/Language'
export default {
    components: {
        LoginTextInput: () => import('../../components/forms/LoginTextInput'),
        LoginSelectInput: () =>
            import('../../components/forms/LoginSelectInput')
    },
    props: {
        vars: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            languageOptions,
            form: {
                language: 'pl',
                name: '',
                surname: '',
                mail: '',
                phone: '',
                password: '',
                repeatPassword: '',
                privacy: false,
                regulations: false
            }
        }
    },
    methods: {
        changeLanguage(lang) {
            this.$Language.selectLanguage(lang)
        },
        async submit() {
            if (!this.validateSubmit()) {
                return
            }
            this.loading = true
            try {
                await this.applyUser()
                this.$emit('applied')
                this.loading = false
            } catch (error) {
                this.$Network.handleError(error)
                this.loading = false
            }
        },
        async applyUser() {
            const data = this.getDataToSend()
            const sid = this.$route.params.sid
            const uuid = this.$route.params.uuid
            return this.$api.post(`v1/contracts/apply-new/${sid}/${uuid}`, data)
        },
        getDataToSend() {
            const { mail, password, name, surname, phone, language } = this.form
            return {
                mail,
                password,
                name,
                surname,
                phone: this.$Utils.clearPhone(phone),
                language,
                vars: this.vars
            }
        },
        validateSubmit() {
            this.errors.errors = []
            Object.keys(this.form).forEach(key => {
                if (this.form[key] === '') {
                    this.errors.set(key)
                }
            })
            if (this.errors.errors.length > 0 || this.loading) {
                return
            }
            if (!this.$Utils.validateMail(this.form.mail)) {
                this.errors.set('mail')
                this.$Notif.error('INVALID_EMAIL_FORMAT')
                return
            }
            if (this.form.password != this.form.repeatPassword) {
                this.errors.set('password')
                this.errors.set('repeatPassword')
                this.$Notif.error('TOAST_PASSWORD_MATCH')
                return
            }
            if (!this.form.regulations || !this.form.privacy) {
                this.$Notif.error('TOAST_ACCEPT_LEGALS')
                return
            }
            return true
        },
        goBack() {
            this.$emit('goBack')
        }
    },
    mounted() {
        this.form.language = this.$i18n.locale
    }
}
</script>
<style lang="scss" scoped>
.apply-login-wrap {
    margin: 0 auto;
    width: 80%;
    display: flex;
    flex-direction: column;

    @media (max-width: 1000px) {
        width: 100%;
    }
}
.form-popup-title {
    font-size: 2rem;
    font-family: $input-family;
    color: $input;
}
</style>
